import { render, staticRenderFns } from "./SignUp3.vue?vue&type=template&id=37a1f7fe&"
import script from "./SignUp3.vue?vue&type=script&lang=ts&"
export * from "./SignUp3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports